if (!customElements.get('jjc-contact-hub')) {
  customElements.define('jjc-contact-hub', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-contact-tab]')];
      this.panels = [...this.querySelectorAll('[data-contact-panel]')];
      this.startedAt = Date.now();
      this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.select(index)));
      this.querySelectorAll('form').forEach((form) => form.addEventListener('submit', (event) => {
        const trap = form.querySelector('[data-human-check]');
        if ((trap && trap.value) || Date.now() - this.startedAt < 1800) event.preventDefault();
      }));
    }

    select(index) {
      this.tabs.forEach((tab, tabIndex) => tab.setAttribute('aria-selected', String(tabIndex === index)));
      this.panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
      this.panels[index]?.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true });
    }
  });
}
